import React, { useEffect, useRef, useState } from 'react';
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faFileCsv, faPencilAlt, faSave } from '@fortawesome/free-solid-svg-icons';

// Components
import MainCard from '../../../components/MainCard/MainCard';
import ModalCustomized from '../../../components/Modal/Modal';

//API
import redestinacao_api from '../../../api/redestinacao_api';

//Helpers
import { showMessage } from 'helpers/message';
import TabelaListagemFichas from 'components/TabelaListagemFichas/TabelaListagemFichas';
import Loading from '../../../components/Loading/Loading';
import { Button, Col, Row } from 'reactstrap';
import mascaras from '../../../helpers/mascaras';
import TextField from '../../../components/TextField/TextField';
import { validarCampos } from '../../../helpers/ValidadorDeCampos';
import { objCampo } from '../../../helpers/ValidadorDeCampos';


function initialStatePeso() {
    return {
        id: "",
        status: "",
        tbRedestinacoes_Id: "",
        peso: ""
    }
}
export default function FichaReceberResiduos({ id, btnVoltar }) {
    //Estado de controle dos dados do redestinação 
    const [redestinacao, setRedestinacao] = useState(null);

    //Estado de controle do loading na tela
    const [loading, setLoading] = useState(false);

    //Estado controle de exibição do modal
    const [openModal, setOpenModal] = useState(false);

    const toggleModal = () => setOpenModal(!openModal);

    //Estado de controle dos errors
    const [errors, setErrors] = useState({});

    const [operacao, setOperacao] = useState(initialStatePeso());

    //referencia do relatorio
    const refRelatorio = useRef();

    //Função assionada assim que o botão de imprimir pdf é clicado
    const handlePrint = useReactToPrint({
        content: () => refRelatorio.current,
        copyStyles: true,
        documentTitle: "Redestinação",
    });

    const headersRedestinacao = [
        { value: "Modalidade", objectValue: "modalidade" },
        { value: "Peso Destinado", objectValue: "pesoDestinado" }
    ];

    //campos obrigatorios dos filtros
    const campos = [
        objCampo({ name: "peso", required: true }),
    ];


    const loadRedestinacao = (id) => {
        setLoading(true);
        redestinacao_api.GetItem(id).then(response => {
            response.data.redestinacaoDestino.id = response.data?.redestinacaoDestino?.id ? response.data.redestinacaoDestino?.id.toString() : "";
            response.data.redestinacaoDestino.pesoEntrada = response.data.redestinacaoDestino.pesoEntrada ? response.data.redestinacaoDestino.pesoEntrada.toString().replace(".", ",") : "";
            response.data.redestinacaoDestino.pesoSaida = response.data.redestinacaoDestino.pesoSaida ? response.data.redestinacaoDestino.pesoSaida.toString().replace(".", ",") : "";
            response.data.tbTransportadores_Id = response.data?.tbTransportadores_Id ? response.data.tbTransportadores_Id.toString() : "";
            response.data.tbVeiculos_Id = response.data?.tbVeiculos_Id ? response.data?.tbVeiculos_Id?.toString() : "";
            response.data.dataRegistro = moment(response.data.dataRegistro).format("DD/MM/YYYY");
            response.data.dataColeta = response.data.dataColeta ? moment(response.data.dataColeta).format("DD/MM/YYYY HH:mm") : "";

            response.data.redestinacaoTipoColetas = response.data.redestinacaoTipoColetas?.map(value => {
                value.pesoDestinado = value.pesoDestinado.toFixed(2).replace(".", ",")
                return value;
            });
            if (response.data)
                setOperacao({
                    id: response.data.redestinacaoDestino.id,
                    tbRedestinacoes_Id: response.data.id,
                    status: response.data.status,
                    peso: ""
                })
            setRedestinacao(response.data)
        }).catch(e => {
            showMessage("Aviso", e.message, "error", null);
        }).finally(f => setLoading(false));
    }

    const InsertRedestinacaoResiduo = () => {

        const erros = validarCampos(operacao, campos);
        setErrors(erros[0]);
        if (erros[1].length > 0) {
            return;
        }

        const _operacao = { ...operacao }
        if (_operacao.status == "Coletado")
            _operacao.pesoEntrada = parseFloat(_operacao.peso.replace(",", "."))
        if (_operacao.status == "Descarregando") {
            _operacao.pesoSaida = parseFloat(_operacao.peso.replace(",", "."))
            if (_operacao.pesoSaida > redestinacao?.redestinacaoDestino?.pesoEntrada) {
                showMessage("Aviso", "Peso de saída não pode ser maior que peso de entrada.", "error", null);
                return;
            }
        }

        delete _operacao.peso;

        setLoading(true);
        redestinacao_api.InsertRedestinacaoResiduo(_operacao)
            .then(response => {
                showMessage("Sucesso", "Operação realizada com sucesso.", "success", btnVoltar);
            }).catch(e => {
                showMessage("Aviso", e.message, "error", null);
            }).finally(f => setLoading(false));
    }

    const onChange = (e) => {
        const { name, value } = e.target;
        const _operacao = { ...operacao, [name]: value }
        const erros = validarCampos(_operacao, campos.filter(c => c.name == name));
        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        }

        setOperacao(_operacao)
    }

    useEffect(() => {
        loadRedestinacao(id);
    }, []);

    return <MainCard
        btnVoltarInTop={btnVoltar}
        btnImprimir={handlePrint}
        BtnAction1InTop={() => <Button className='mb-3' color='success' onClick={() => setOpenModal(true)}>
            <>
                <FontAwesomeIcon icon={faSave} /> {redestinacao?.status == "Coletado" ? "Confirmar Entrada" : "Confirmar Saída"}
            </>
        </Button>}
    >
        {loading && <Loading />}
        <ModalCustomized
            isOpen={openModal}
            toggle={toggleModal}
            btnClose
        >
            <Row>
                <Col md="12" lg="12">
                    <TextField
                        label={redestinacao?.status == "Coletado" ? "* Confirmar Entrada" : "* Confirmar Saída"}
                        name="peso"
                        mask={mascaras.floatMask}
                        value={operacao.peso}
                        onChange={onChange}
                        invalid={!!errors.peso}
                    />
                </Col>
            </Row>
            <div className='d-flex justify-content-center align-items-center'>
                <Button color="success" onClick={InsertRedestinacaoResiduo}>
                    <FontAwesomeIcon icon={faSave} color='white' />  Salvar
                </Button>
            </div>
        </ModalCustomized>
        <div style={{ color: "#666" }} className="mt-4 relatorio w-100" ref={refRelatorio}>
            <div className='m-2 body'>
                <h5
                    className='p-2 rounded-3 bg-primary bg-gradient fw-normal d-flex justify-content-between align-items-center'
                    style={{ color: "#fff" }}
                >
                    <span><FontAwesomeIcon icon={faPencilAlt} className={"me-3"} />Origem</span>
                </h5>
                <div className='row mb-2'>
                    <div className='col-md-12 col-lg-6'>
                        <p><span className="fw-bold">Destino Origem: </span> {redestinacao?.destinoOrigem}</p>
                    </div>
                    <div className='col-md-12 col-lg-6'>
                        <p><span className="fw-bold">Transportador: </span> {redestinacao?.transportadorFantasia}</p>
                    </div>
                    <div className='col-md-12 col-lg-6'>
                        <p><span className="fw-bold">Veiculo: </span> {redestinacao?.placaVeiculo}</p>
                    </div>
                    <div className='col-md-12 col-lg-6'>
                        <p><span className="fw-bold">Data/Hora Registro: </span> {redestinacao?.dataRegistro}</p>
                    </div>
                    <div className='col-md-12 col-lg-6'>
                        <p><span className="fw-bold">Data/Hora Coleta: </span> {redestinacao?.dataColeta}</p>
                    </div>
                </div>

                <h5
                    className='p-2 rounded-3 bg-primary bg-gradient fw-normal d-flex justify-content-between align-items-center'
                    style={{ color: "#fff" }}
                >
                    <span><FontAwesomeIcon icon={faPencilAlt} className={"me-3"} />Destino</span>
                </h5>
                <div className='row mb-2'>
                    <div className='col-md-12 col-lg-6'>
                        <p><span className="fw-bold">Destino Envio: </span> {redestinacao?.redestinacaoDestino?.destinoFantasia}</p>
                    </div>
                    <div className='col-md-12 col-lg-6'>
                        <p><span className="fw-bold">Data/Hora: </span>  {redestinacao?.dataColeta}</p>
                    </div>
                    <div className='col-md-12 col-lg-6'>
                        <p><span className="fw-bold">Peso Entrada: </span> {!!redestinacao?.redestinacaoDestino?.pesoEntrada ? redestinacao?.redestinacaoDestino?.pesoEntrada : "0,00"} KG</p>
                    </div>
                    <div className='col-md-12 col-lg-6'>
                        <p><span className="fw-bold">Peso Saida: </span> {!!redestinacao?.redestinacaoDestino?.pesoSaida ? redestinacao?.redestinacaoDestino?.pesoSaida : "0,00"} KG</p>
                    </div>
                </div>

                <h5
                    className='p-2 rounded-3 bg-primary bg-gradient fw-normal d-flex justify-content-between align-items-center'
                    style={{ color: "#fff" }}
                >
                    <span><FontAwesomeIcon icon={faPencilAlt} className={"me-3"} />Modalidades de Coleta</span>
                </h5>
                <div className="row">
                    <div className='col-md-12 col-lg-12 w-100 '>
                        <TabelaListagemFichas headers={headersRedestinacao} items={redestinacao?.redestinacaoTipoColetas} width={"100%"} />
                    </div>
                </div>
            </div>
        </div>
    </MainCard>;
}